import {SplitPageLayout} from '@primer/react'
import {Diff} from '../components/Commit/Diff'
import {FileTree} from '../components/Commit/FileTree'
import {CommitInfo} from '../components/Commit/CommitInfo'
import {useState} from 'react'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {CommitPayload} from '../types/commit-types'

export function Commit() {
  const payload = useRoutePayload<CommitPayload>()
  const treeEnabled = payload.files.length > 1

  const [treeExpanded, setTreeExpanded] = useState(treeEnabled)

  return (
    <SplitPageLayout>
      <SplitPageLayout.Header>
        <CommitInfo commit={payload.commit} />
      </SplitPageLayout.Header>
      <SplitPageLayout.Pane hidden={!treeExpanded}>
        <FileTree diffs={payload.files} onSelect={() => {}} />
      </SplitPageLayout.Pane>
      <SplitPageLayout.Content>
        <Diff setTreeExpanded={setTreeExpanded} treeExpanded={treeExpanded} treeEnabled={treeEnabled} />
      </SplitPageLayout.Content>
    </SplitPageLayout>
  )
}

try{ Commit.displayName ||= 'Commit' } catch {}